export class DefaultConfigurationProvider {
    getConfiguration() {
        return {
            openingTime: { hours: 7, minutes: 30 },
            closingTime: { hours: 21, minutes: 0 },
        };
    }
}
